"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const UIRadio2_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIRadio2.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const Alchemy_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Alchemy"));
const trans_1 = require("@common/tsutils/trans");
const CRITERIAS = ['avg', 'med', 'min', 'max'];
let AlchemyRecipe = class AlchemyRecipe extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.output = [];
        this.myOption = this.option;
        this.options = CRITERIAS.map(criteria => ({
            value: criteria,
            label: (0, trans_1.trans)('heatmap.alchemy.criterias.' + criteria),
        }));
    }
    onChangeOption() {
        this.myOption = this.option;
    }
    onChangeMyOption() {
        this.$emit('change-option', this.myOption);
        this.buildOutput();
    }
    mounted() {
        this.buildOutput();
    }
    buildOutput() {
        this.output = Alchemy_1.default.create(this.samples, this.myOption, this.groupBy);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AlchemyRecipe.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AlchemyRecipe.prototype, "option", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AlchemyRecipe.prototype, "groupBy", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('option')
], AlchemyRecipe.prototype, "onChangeOption", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('myOption')
], AlchemyRecipe.prototype, "onChangeMyOption", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('samples'),
    (0, vue_property_decorator_1.Watch)('groupBy')
], AlchemyRecipe.prototype, "buildOutput", null);
AlchemyRecipe = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            UIRadio: UIRadio2_vue_1.default,
            GitMerge: lucide_vue_next_1.GitMerge
        }
    })
], AlchemyRecipe);
exports.default = AlchemyRecipe;
